var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccountLine = function SvgAccountLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.582 10.833q.144 0 .285.012.034.001.068.005a4 4 0 0 1 .594.104l.018.005q.135.035.264.081l.022.007a3.75 3.75 0 0 1 1.923 5.531l1.582 1.582-1.178 1.179-1.582-1.582a3.75 3.75 0 1 1-1.996-6.924m1.251-1.52a5.416 5.416 0 0 0-6.25 7.355H2.5V5.832A3.333 3.333 0 0 1 5.833 2.5h10zm-5.23-2.135-2.5-1.667-2.13 3.193 1.387.925 1.204-1.807 2.5 1.667 2.13-3.193-1.387-.925z"
  })));
};
export default SvgAccountLine;